export const CAR_NUMBER_PASS_NAME = 'Номер автомобиля'

export function getPassLimit(name) {
  return name === CAR_NUMBER_PASS_NAME ? 3 : 1
}
